import { Get, Put } from 'config/apiServiceConfig'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { Outbound } from '../@types'

export type ValidateTruckInformationType = {
  driver_id: number
  driver_provider_id: Nullable<number>
  driver_name: string
  plate_number: string
  vehicle_type: string
  start_fresh_temperature: number
  end_fresh_temperature: number
  driver_type: string
}

export type GetConfigurationResponseType = {
  data: {
    cancelLoadingReasons: {
      code: string
      name: string
    }[]
    needToSetTemperatureLocationIds: number[]
    supportedVehicleType: {
      key: string
      value: string
    }[]
  }
}

type Get3PLResponseInterface = {
  data: {
    id: number
    name: string
  }[]
}

type GetDriversAstroResponseType = {
  data: Outbound.DriverAstroType[]
}

type PutOnDeliveryPayloadType = Omit<
  Outbound.ReadyToShipFormType,
  'driver' | 'vehicleType' | 'selectedAstroDriver'
> & {
  driverId: Nullable<number>
  vehicleType: string
  loadingIDs: number[]
}

type GetListStaffByRoleRequestType = {
  role_name: string
  location_id: number
}

type GetListStaffByRoleResponseType = {
  staff_created_at: string
  staff_vehicle_type: string
  staff_location_id: number
  staff_role: string
  staff_phone_number: string
  join_date: string
  staff_plate_number: string
  termination_reason: string
  staff_active: boolean
  staff_status: string
  is_blacklist: boolean
  staff_employment_type: string
  hired_role: string
  staff_location_type: string
  staff_vehicle_sub_type: string
  staff_location_name: string
  working_location_id: number
  staff_card_number: string
  termination_date: string
  staff_full_name: string
  employee_detail: number
  staff_id: number
  staff_app_version: string
  staff_tracker_id: string
  user_id: number
  updated_by: string
  created_by: string
  staff_verified: boolean
  staff_updated_at: string
}[]

type PostAssignCheckerPackerRequestType = {
  checker_id: number
  packer_ids: number[]
}

export const getValidateInformationTruck = (loadingIds: number[]) =>
  Get<{ data: ValidateTruckInformationType }>({
    url: '/api/wms/:version/supply-order/loading/validate-truck-information',
    version: 'v1',
    params: {
      supply_order_loading_ids: loadingIds.join(','),
    },
  })

export const getConfiguration = () =>
  Get<GetConfigurationResponseType>({
    url: `/api/wms/:version/supply-order/loading/configurations`,
    version: 'v1',
  })

export const get3PL = () =>
  Get<Get3PLResponseInterface>({
    url: '/api/wms/:version/supply-order/loading/3pl-providers',
    version: 'v1',
  })

export const getDriversAstro = (locationId: number) =>
  Get<GetDriversAstroResponseType>({
    url: '/api/wms/:version/supply-order/loading/drivers',
    version: 'v1',
    params: { locationId },
  })

export const putOnDelivery = (data: PutOnDeliveryPayloadType) =>
  Put<{ message: string }>({
    url: '/api/wms/:version/supply-order/update-on-delivery',
    version: 'v2',
    data,
  })

export const putSupplyOrderGrandStatus = (
  supplyOrderId: Outbound.SupplyOrderType['supplyOrderId'],
  payload: { status: string },
) =>
  Put({
    url: '/api/wms/:version/supply-order/:supplyOrderId/status',
    version: 'v2',
    urlParams: { supplyOrderId },
    data: payload,
  })

export const getListStaffByRoleAPI = (data: GetListStaffByRoleRequestType) =>
  axiosInstanceApiGateway.Post<GetListStaffByRoleResponseType>({
    url: 'staff-management/internal/v1/staff/get-by-role',
    data,
  })

export const postAssignCheckerPackerAPI = (
  soId: number,
  payload: PostAssignCheckerPackerRequestType,
) =>
  axiosInstanceApiGateway.Post({
    url: `/wms/internal/v1/supply-order/${soId}/checker-packer`,
    data: payload,
  })
